<script>
export default {
  name: `TransitionExpand`,
  functional: true,
  render(createElement, context) {
    const data = {
      props: {
        name: `expand`,
      },
      on: {
        beforeEnter(element) {
          requestAnimationFrame(() => {
            if (!element.style.height) {
              element.style.height = '0px'
            }
            element.style.display = null
          })
        },
        enter(element) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              element.style.height = `${element.scrollHeight}px`
            })
          })
        },
        afterEnter(element) {
          element.style.height = null
        },
        beforeLeave(element) {
          requestAnimationFrame(() => {
            if (!element.style.height) {
              element.style.height = `${element.offsetHeight}px`
            }
          })
        },
        leave(element) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              element.style.height = '0px'
            })
          })
        },
        afterLeave(element) {
          element.style.height = null
        },
      },
    }
    return createElement(`transition`, data, context.children)
  },
}
</script>
